<div class="tw-flex tw-items-center tw-justify-center tw-gap-0.5 tw-bg-white tw-px-4 tw-py-3">
  @for (step of steps(); track step.key; let last = $last) {
    <div class="tw-flex tw-items-center tw-gap-0.5">
      <cs-icon class="tw-h-3 tw-w-3"
        [class.tw-text-teal-500]="step.state !== OrderFlowStepState.PENDING"
        [class.tw-text-gray-400]="step.state === OrderFlowStepState.PENDING"
        [iconName]="step.iconName"></cs-icon>
      <span class="tw-text-200 tw-font-lexend"
        [class.tw-font-bold]="step.state === OrderFlowStepState.ACTIVE"
        [class.tw-font-normal]="step.state !== OrderFlowStepState.ACTIVE"
        [class.tw-text-teal-500]="step.state !== OrderFlowStepState.PENDING"
        [class.tw-text-gray-400]="step.state === OrderFlowStepState.PENDING">
        @switch (step.key) {
          @case (OrderFlowStep.CART) { <ng-container i18n="@@cartStepLabel">Cart</ng-container> }
          @case (OrderFlowStep.ADDRESS) { <ng-container i18n="@@addressStepLabel">Address</ng-container> }
          @case (OrderFlowStep.PAYMENT) { <ng-container i18n="@@paymentStepLabel">Payment</ng-container> }
        }
      </span>
    </div>
    @if (!last) {
      <div class="tw-h-px tw-w-14"
        [class.tw-bg-teal-500]="step.state === OrderFlowStepState.COMPLETED"
        [class.tw-bg-gray-400]="step.state !== OrderFlowStepState.COMPLETED"></div>
    }
  }
</div>
